<div *ngIf="abstractControl">
  <p class="error-message" *ngFor="let message of errorMessages">
    {{ message }}
  </p>
</div>
